import { Box, type BoxProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import error403 from '../images/403.svg';

const StyledErrorContainer = styled(Box)`
    text-align: center;
`;

const StyledErrorMessage = styled(Typography)`
    text-align: center;
`;

const Error403 = (props?: BoxProps) => {
    const { t } = useTranslation('error_messages');

    return (
        <StyledErrorContainer {...props}>
            <img src={error403}></img>
            <StyledErrorMessage variant="h4">{t('http-403.noPermission')}</StyledErrorMessage>
            <StyledErrorMessage variant="h5">{t('http-403.contactAdministrator')}</StyledErrorMessage>
        </StyledErrorContainer>
    );
};

export default Error403;
